export const ORDER_CREATE_REQ = 'orders-groups-create-req/ORDER_CREATE_REQ';
export const orderCreateReqAction = payload => ({
	type: ORDER_CREATE_REQ,
	payload,
});

export const GET_CATEGORIES = 'orders-groups-create-req/GET_CATEGORIES';
export const getCategoriesAction = payload => ({
	type: GET_CATEGORIES,
	payload,
});

export const SET_CATEGORIES = 'orders-groups-create-req/SET_CATEGORIES';
export const setCategoriesAction = payload => ({
	type: SET_CATEGORIES,
	payload,
});

export const SET_IS_CATEGORIES_LOADING = 'orders-groups-create-req/SET_IS_CATEGORIES_LOADING';
export const setIsCategoriesLoadingAction = payload => ({
	type: SET_IS_CATEGORIES_LOADING,
	payload,
});

export const GET_TENDER_TYPES = 'orders-groups-create-req/GET_TENDER_TYPES';
export const getTenderTypesAction = payload => ({
	type: GET_TENDER_TYPES,
	payload,
});

export const SET_TENDER_TYPES = 'orders-groups-create-req/SET_TENDER_TYPES';
export const setTenderTypesAction = payload => ({
	type: SET_TENDER_TYPES,
	payload,
});

export const SET_IS_TENDER_TYPES_LOADING = 'request-form/SET_IS_TENDER_TYPES_LOADING';
export const setIsTenderTypesLoading = payload => ({
	type: SET_IS_TENDER_TYPES_LOADING,
	payload,
});

export const GET_TENDER_COMPANIES = 'orders-groups-create-req/GET_TENDER_COMPANIES';
export const getTenderCompaniesAction = payload => ({
	type: GET_TENDER_COMPANIES,
	payload,
});

export const SET_TENDER_COMPANIES = 'orders-groups-create-req/SET_TENDER_COMPANIES';
export const setTenderCompaniesAction = payload => ({
	type: SET_TENDER_COMPANIES,
	payload,
});

export const SET_IS_TENDER_COMPANIES_LOADING = 'request-form/SET_IS_TENDER_COMPANIES_LOADING';
export const setIsTenderCompaniesLoadingAction = payload => ({
	type: SET_IS_TENDER_COMPANIES_LOADING,
	payload,
});

export const GET_TYPES = 'orders-groups-create-req/GET_TYPES';
export const getTypesAction = payload => ({
	type: GET_TYPES,
	payload,
});

export const SET_TYPES = 'orders-groups-create-req/SET_TYPES';
export const setTypesAction = payload => ({
	type: SET_TYPES,
	payload,
});

export const SET_IS_TYPES_LOADING = 'request-form/SET_IS_TYPES_LOADING';
export const setIsTypesLoadingAction = payload => ({
	type: SET_IS_TYPES_LOADING,
	payload,
});

export const RESET_STATE = 'orders-groups-create-req/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
